import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import DirectusSDK from '@directus/sdk-js';
import App from './App.vue'
import router from './router'
import i18n from './i18n';
import PinchZoom from 'vue-pinch-zoom';
Vue.component('pinch-zoom', PinchZoom);
import VueLayers from 'vuelayers'
import 'vuelayers/lib/style.css' // needs css-loader
import Footer from '@/components/Footer';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './scss/main.css'

import utilities from '@/utilities'
import VueObserveVisibility from 'vue-observe-visibility'
import VueSessionStorage from 'vue-sessionstorage'

Vue.use(VueLayers)
Vue.config.productionTip = false;
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Footer)
Vue.use(VueObserveVisibility)
Vue.use(VueSessionStorage)

const client = new DirectusSDK({
  url: "https://backoffice.museovirtuale.unimi.it",
  project: "museovirtuale"
});

Object.defineProperties(Vue.prototype, {
  $client: { value: client },
  $utilities: { value: utilities },
});

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');


